import React from 'react'
import { View, TouchableOpacity, Image, Clipboard } from 'react-native'
import _ from 'lodash'
// import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import * as subscriptionUtil from 'x/utils/subscriptionUtil'
import BaseProductBundlesDetailView, { IProductBundle } from 'x/modules/order/BaseProductBundlesDetailView'
import * as xFmt from 'x/utils/formatter'
import XCustomHeader from 'xui/components/XCustomHeader'
// import { Input } from 'react-native-elements'
import { STYLES, COLORS, S } from 'x/config/styles'
import XInput from 'xui/components/XInput'
import XIcon, { XIconFamily } from 'xui/components/XIcon'
import XForceCreateShipping from 'xui/components/XForceCreateShipping'
import { IAddress, IMKPChannelDetail, IOverlaySetupSyncOrderCallBack } from 'x/index'
import { VIEW_WIDTH_TEN } from 'xui/utils/BaseShareUI'
import * as NavActions from 'x/utils/navigation'
import { isImmutable } from 'immutable'
import CONS from 'x/config/constants'
import HelpButton from 'xui/components/HelpButton'
import SyncBtn from 'xui/components/SyncBtn'
import OverlaySetupSyncOrder from 'xui/modules/channels/OverlaySetupSyncOrder'
import OverlaySyncMKPProduct from 'xui/modules/channels/OverlaySyncMKPProduct'
import XDropdown from 'xui/components/XDropdown'
import DotDotDotVerticalIcon from 'xui/components/DotDotDotVerticalIcon'
import p from 'x/config/platform-specific'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCard from 'xui/components/XCard'
import VStack from 'xui/components/VStack'
import Box from 'xui/components/Box'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XIconButton from 'xui/components/XIconButton'
import XButton from 'xui/components/XButton'
import XRadioList from 'xui/components/XRadioList'
import XHelpModal from 'xui/components/XHelpModal'
import XFaqModal from 'xui/components/XFaqModal'
import FAQ from 'x/config/FAQ'
import FAQ_CONSTANTS from 'x/config/FAQ_CONSTANTS'
import MkpLogo from 'xui/components/MkpLogo'
import XSwitch from 'xui/components/XSwitch'
// import XSegment from 'xui/components/XSegment'
import XFlatPicker from 'xui/components/XFlatPicker'
import * as acl from 'x/utils/acl'
import XImageIcon from 'xui/components/XImageIcon'
import XImage from 'xui/components/XImage'

const VIEW_STYLE_PENDDING = { paddingLeft: 16, paddingRight: 16 }

const _renderAgreement = (onPressOpenOverlay: () => void) => <HelpButton onPress={() => onPressOpenOverlay()} />

export default abstract class BaseUIProductBundlesDetailView extends BaseProductBundlesDetailView {
  // abstract _renderMain: () => JSX.Element
  // abstract renderImageDocumentUpload: () => JSX.Element
  // abstract goBack: () => void

  // abstract navToProductGroupList: () => void
  // abstract navToToAddressViewFromStoreMyView: (isPrimary: boolean, address?: ISelectedAddresses) => void
  // abstract _renderHamburgerButton: () => JSX.Element

  renderCustomHeader = () => {
    const leftBtn = {
      backIcon: true,
      onPressItem: () => this._goBack(),
    }
    const rightBtn = {
      label: ' ',
      onPressItem: () => null,
    }
    const titleHeader = 'รายละเอียดสินค้าเซต'
    return <XCustomHeader title={titleHeader} headerLeftProps={leftBtn} headerRightProps={rightBtn} />
  }

  _loading = () => {
    const { isLoading, loadingWidth, loadingHeight } = this.state
    if (!isLoading) {
      return null
    }
    return (
      <Box
        style={{
          // zIndex: 999,
          position: 'absolute',
          width: loadingWidth,
          height: loadingHeight,
          backgroundColor: 'rgba(52, 52, 52, 0.7)',
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          marginTop: 12,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <XButton isLoading variant='ghost' />
      </Box>
    )
  }

  _renderTitleDescription = () => {
    const { product, showProfit } = this.state
    console.log('product => ', product)
    if (_.isNil(product)) {
      return null
    }

    const price_after_discount = product.price_after_discount || '0'
    const cost = product.cost || '0'
    const profit = +price_after_discount - +cost
    const price = product.price || '0'

    const priceRender =
      price === price_after_discount ? (
        <XText bold>{xFmt.formatCurrency(price)}</XText>
      ) : (
        <HStack>
          <XText textDecorationLine='line-through' variant='inactive'>
            {xFmt.formatCurrency(price)}
          </XText>
          <XText ml='2' bold>
            {xFmt.formatCurrency(price_after_discount)}
          </XText>
        </HStack>
      )

    return (
      <VStack w='full' h={showProfit ? '130px' : '110px'} p='2' bgColor={COLORS.BLUE_TAB}>
        <HStack w='full'>
          <XImage source={{ uri: product.thumbnail_uris[0] }} alt='image' w='60px' h='60px' borderRadius='md' resizeMode='cover' />
          <VStack ml='2' flex={1}>
            <XText numberOfLines={1} variant='inactive' fontSize={'xs'}>
              {product.name}
            </XText>
            <XText numberOfLines={1} variant='active' bold>
              {`${product.variant}`}
            </XText>
            {/* <XText numberOfLines={1} variant='active' fontSize={'xs'} bold>
              {`${xFmt.formatCurrency(product.price)}`}
            </XText> */}
            {priceRender}
            <XText numberOfLines={1} fontSize={'xs'} variant='inactive'>
              {`SKU: ${product.sku}`}
            </XText>
            <XText numberOfLines={1} fontSize={'xs'} variant='inactive'>
              {`UPC: ${product.upc}`}
            </XText>
          </VStack>
          <VStack w={'16'} flexDirection={'flex-end'} alignItems={'flex-end'}>
            <XText fontSize={'2xl'} bold>{`x ${product.qty}`}</XText>
          </VStack>
        </HStack>
        {showProfit ? (
          <XText numberOfLines={1} variant='inactive' color={COLORS.BRAND_Success}>
            {`กำไร: ${xFmt.formatCurrency(profit)}`}
          </XText>
        ) : null}
      </VStack>
    )
  }

  _renderProductBundleDetail = (icon: { name: string; family: XIconFamily }, label: string, value: string, isMoney = false) => {
    return (
      <HStack w='full' alignItems={'center'} justifyContent={'center'}>
        <HStack w='8'>
          <XIcon name={icon.name} family={icon.family} color={COLORS.TEXT_INACTIVE} />
        </HStack>
        <HStack flex={1}>
          <XText>{label}</XText>
        </HStack>
        {isMoney ? (
          <HStack w='20' justifyContent='flex-end'>
            <XText>{'฿'}</XText>
          </HStack>
        ) : null}
        <HStack flex={1} justifyContent={'flex-end'}>
          <XText>{value}</XText>
        </HStack>
      </HStack>
    )
  }

  _renderProductBundles = (productBundle: IProductBundle) => {
    const { showProfit } = this.state
    const name = productBundle.variant || ''
    const imgs = productBundle.thumbnail_uris || []
    const price = productBundle.price || '0'

    const price_after_discount = productBundle.price_after_discount || '0'
    const cost = productBundle.cost || '0'
    const profit = +price_after_discount - +cost

    const priceRender =
      price === price_after_discount ? (
        <XText bold>{xFmt.formatCurrency(price)}</XText>
      ) : (
        <HStack>
          <XText textDecorationLine='line-through' variant='inactive'>
            {xFmt.formatCurrency(price)}
          </XText>
          <XText ml='2' bold>
            {xFmt.formatCurrency(price_after_discount)}
          </XText>
        </HStack>
      )
    return (
      <XCard mx='2' mt='2' p='2'>
        <HStack w='full'>
          <XImage source={{ uri: imgs[0] }} alt='image' w='50px' h='50px' borderRadius='md' resizeMode='cover' />
          <VStack ml='2' flex={1}>
            <XText numberOfLines={1} variant='inactive' fontSize={'xs'}>
              {name}
            </XText>
            <XText numberOfLines={1} variant='active' bold>
              {productBundle.variant}
            </XText>
            {priceRender}
            <XText numberOfLines={1} fontSize={'xs'} variant='inactive'>
              {`SKU: ${productBundle.sku}`}
            </XText>
            <XText numberOfLines={1} fontSize={'xs'} variant='inactive'>
              {`UPC: ${productBundle.upc}`}
            </XText>
          </VStack>
          <VStack w={'16'} flexDirection={'flex-end'} alignItems={'flex-end'}>
            <XText fontSize={'lg'} bold>{`x ${productBundle.qty}`}</XText>
          </VStack>
        </HStack>
        {/* <VStack mt='10' space={'2'}> */}
        {/* {this._renderProductBundleDetail({ name: 'box', family: 'FontAwesome5' }, 'จำนวน (ต่อเซต)', `x ${productBundle.qty}`, false)} */}
        {/* {this._renderProductBundleDetail({ name: 'pricetag', family: 'Ionicons' }, 'ราคาขาย', price, true)} */}
        {/* {this._renderProductBundleDetail({ name: 'pricetag', family: 'Ionicons' }, 'ต้นทุน', cost, true)} */}
        {/* {this._renderProductBundleDetail(
            { name: 'barcode-scan', family: 'MaterialCommunityIcons' },
            'ราคาหลังส่วนลด',
            price_after_discount,
            false
          )} */}
        {/* {this._renderProductBundleDetail(
            { name: 'local-shipping', family: 'MaterialIcons' },
            'จัดส่งแล้ว',
            `${productBundle.shipped_qty} / ${productBundle.qty}`,
            false
          )} */}
        {/* </VStack> */}
        {showProfit ? (
          <XText numberOfLines={1} variant='inactive' color={COLORS.BRAND_Success}>
            {`กำไร: ${xFmt.formatCurrency(profit)}`}
          </XText>
        ) : null}
      </XCard>
    )
  }

  _renderContent = () => {
    const { productBundles } = this.state
    // console.log('productBundles => ', productBundles)
    if (_.isNil(productBundles)) {
      return null
    }
    return (
      <VStack w='full' bgColor={COLORS.WHITE} pb='2'>
        {productBundles.map((productBundle) => this._renderProductBundles(productBundle))}
      </VStack>
    )
  }

  _renderCountQty = () => {
    const { productBundles } = this.state
    if (_.isNil(productBundles)) {
      return null
    }
    const productLength = productBundles.length
    const qtyTotal = _.sumBy(productBundles, 'qty')
    return (
      <HStack bgColor={COLORS.WHITE} pt={'4'} pl='2'>
        <XText bold variant='inactive'>{`รายการสินค้าในเซต (สินค้า: ${productLength}, จำนวน: ${qtyTotal})`}</XText>
      </HStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this.renderCustomHeader()}
        <XContent
          onLayout={(event) => {
            const { x, y, width, height } = event.nativeEvent.layout
            util.setStatePromise(this, { loadingWidth: width, loadingHeight: height })
          }}>
          {this._renderTitleDescription()}
          {this._renderCountQty()}
          {this._renderContent()}
        </XContent>
        {this._loading()}
      </XContainer>
    )
  }
}
